const defaults = {
  tokenUri: '/connect/token',
  logoutUri: '/connect/logout',
  logoutRedirectTo: 'login',
  unauthorizedRedirectTo: 'login',
  forbiddenRedirectTo: 'forbidden',
  twoFactorRedirectTo: 'twofactorauthentication',
  userInfoUri: '/connect/userinfo',
  scope: 'openid offline_access email profile roles',
  rememberMeDuration: 14, //in days
  tokenStorageType: 'localStorage',
  tokenStorageNamespace: 'oidc-client',
};

export default defaults;